<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">PaxelRecycle - Why Use PaxelRecycle</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Why Use PaxelRecycle</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="title-id"
          >
            <input
              v-model="item.title.id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="title-id"
              class="form-control"
              placeholder="Title in Bahasa"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (English)"
            label-class="control-label"
            class="required"
            label-for="title-en"
          >
            <input
              v-model="item.title.en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Title English"
              id="title-en"
              class="form-control"
              placeholder="Title in English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="description-id"
          >
            <input
              v-model="item.description.id"
              v-validate="'required'"
              name="description_id"
              data-vv-as="Description Bahasa"
              id="description-id"
              class="form-control"
              placeholder="Description in Bahasa"
            />
            <b-form-invalid-feedback id="input-description_id-feedback">{{
              veeErrors.first("description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (English)"
            label-class="control-label"
            class="required"
            label-for="description-en"
          >
            <input
              v-model="item.description.en"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Description English"
              id="description-en"
              class="form-control"
              placeholder="Description in English"
            />
            <b-form-invalid-feedback id="input-description_en-feedback">{{
              veeErrors.first("description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image (JPG/PNG):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.png/.jpg)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(580px x 380px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileJpg"
                  name="imagejpg"
                  data-vv-as="Image JPG/PNG"
                  v-validate="
                    !item.image_jpg
                      ? 'required|minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:jpg,png,jpeg'
                      : 'minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:jpg,png,jpeg'
                  "
                  style="display: none"
                  v-on:change="onChangeFileJpg()"
                />
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="!item.image_jpg && !fileJpg"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_jpg || fileJpg"
                  variant="primary"
                  @click="modalJpg = !modalJpg"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="item.image_jpg || fileJpg"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagejpg") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image (Webp):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.webp)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(580px x 380px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileWebp"
                  name="imagewebp"
                  data-vv-as="Image Webp"
                  v-validate="
                    !item.image_jpg
                      ? 'required|minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:webp'
                      : 'minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:webp'
                  "
                  style="display: none"
                  v-on:change="onChangeFileWebp()"
                />
                <b-button
                  @click="$refs.fileWebp.click()"
                  v-show="!item.image_webp && !fileWebp"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_webp || fileWebp"
                  variant="primary"
                  @click="modalWebp = !modalWebp"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileWebp.click()"
                  v-show="item.image_webp || fileWebp"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagewebp") }}
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Image Alt Text"
            label-class="control-label"
            class="required"
            label-for="image-alt-text"
          >
            <input
              v-model="item.image_alt"
              v-validate="'required'"
              name="image_alt_Text"
              data-vv-as="Image Alt Text"
              id="image-alt-text"
              class="form-control"
              placeholder="Image Alt Text"
            />
            <b-form-invalid-feedback id="input-image_alt_Text-feedback">{{
              veeErrors.first("image_alt_Text")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="item.status"
              :options="optionsStatus"
              name="radio-status"
              v-validate="'required'"
              data-vv-as="Status"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-status') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelRecycleReason' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalJpg" title="Preview Image" size="xl">
      <img
        v-show="!fileJpg"
        v-if="item.image_jpg"
        width
        height="400px"
        :src="item.image_jpg"
      />
      <img
        v-show="fileJpg"
        v-if="urlJpg"
        width
        height="400px"
        :src="urlJpg"
      />
    </b-modal>
    <b-modal v-model="modalWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileWebp"
        v-if="item.image_webp"
        width
        height="400px"
        :src="item.image_webp"
      />
      <img
        v-show="fileWebp"
        v-if="urlWebp"
        width
        height="400px"
        :src="urlWebp"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        title: {
          id: "",
          en: ""
        },
        description: {
          id: "",
          en: ""
        },
        image_jpg: "",
        image_webp: "",
        image_alt: "",
        status: "",
      },
      optionsStatus: [
        { text: "Display", value: "display" },
        { text: "Hide", value: "hide" },
      ],
      loading: false,
      modalJpg: false,
      modalWebp: false,
      fileJpg: "",
      fileWebp: "",
      urlJpg: "",
      urlWebp: ""
    }
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("title_id", this.item.title.id);
          formData.append("title_en", this.item.title.en);
          formData.append("description_id", this.item.description.id);
          formData.append("description_en", this.item.description.en);
          formData.append("image_jpg", this.fileJpg);
          formData.append("image_webp", this.fileWebp);
          formData.append("image_alt", this.item.image_alt);
          formData.append("status", this.item.status);
          this.$store
            .dispatch("PaxelRecycleReasonModule/postReason", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "PaxelRecycleReason" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileJpg() {
      this.fileJpg = this.$refs.fileJpg.files[0];
      const input = this.$refs.fileJpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileWebp() {
      this.fileWebp = this.$refs.fileWebp.files[0];
      const input = this.$refs.fileWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>